var g = Object.defineProperty;
var C = (i, e, t) => e in i ? g(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var l = (i, e, t) => C(i, typeof e != "symbol" ? e + "" : e, t);
import { u as d, a as f } from "./chunk-useConsent-BeRwloLQ.js";
const r = "live-chat";
class b {
  constructor() {
  }
  set() {
    localStorage.setItem(r, Date.now().toString());
  }
  get() {
    if (!localStorage.getItem(r))
      return !1;
    const e = new Date(JSON.parse(localStorage.getItem(r) || "")), s = (/* @__PURE__ */ new Date()).getTime() - e.getTime();
    return Math.floor(s / 1e3 / 60 / 60) < 24;
  }
  clear() {
    localStorage.removeItem(r);
  }
}
const u = new b();
class v extends HTMLElement {
  constructor() {
    super();
    l(this, "consentDebug", !1);
    this.button = this.querySelector("button"), this.shopURL = "";
  }
  connectedCallback() {
    this.init(), this.shopURL = window.Shopify.shop, this.button.addEventListener("click", this.handleFauxClick.bind(this)), document.addEventListener("click", (t) => {
      this.handleExternalClicks(t);
    });
  }
  init() {
    this.chatInitiated = u.get() || !1, this.prepareLiveChatWindow(), d(
      () => {
        if (this.consentDebug && console.log("Check consent for LiveChat"), this.chatInitiated) {
          this.consentDebug && console.log("LiveChat already initiated"), this.initLiveChat();
          return;
        }
        this.setFauxChatVisible(!0);
      },
      () => {
        this.consentDebug && console.log("No consent for LiveChat"), this.setFauxChatVisible(!0);
      },
      ["marketing", "analytics"],
      !1,
      this.consentDebug
    ), f(
      () => {
        this.excludedPage || this.initLiveChat();
      },
      () => {
        this.hideLiveChat();
      },
      ["marketing", "analytics"],
      this.consentDebug
    );
  }
  prepareLiveChatWindow() {
    const t = this.shopURL || "wosg.myshopify.com";
    (function(s, n, o) {
      function c(a) {
        return h._h ? h._h.apply(null, a) : h._q.push(a);
      }
      var h = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function() {
          c(["on", o.call(arguments)]);
        },
        once: function() {
          c(["once", o.call(arguments)]);
        },
        off: function() {
          c(["off", o.call(arguments)]);
        },
        get: function() {
          if (!h._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            );
          return c(["get", o.call(arguments)]);
        },
        call: function() {
          c(["call", o.call(arguments)]);
        },
        init: function() {
          var a = n.createElement("script");
          a.async = !0, a.type = "text/javascript", a.id = "LiveChatScript", a.src = `https://shopify.livechatinc.com/api/v1/script/shop/${t}/widget.js`, n.head.appendChild(a);
        }
      };
      s.LiveChatWidget = s.LiveChatWidget || h;
    })(window, document, [].slice);
  }
  initLiveChat(t = !1) {
    LiveChatWidget.init(), this.setChatInitiated(!0), this.setFauxChatVisible(!1), t ? LiveChatWidget.call("maximize") : LiveChatWidget.call("minimize");
  }
  hideLiveChat() {
    LiveChatWidget.call("hide"), this.setChatInitiated(), this.setFauxChatVisible();
  }
  setChatInitiated(t = !1) {
    t ? this.chatInitiated || (u.set(), this.chatInitiated = !0) : (u.clear(), this.chatInitiated = !1);
  }
  setFauxChatVisible(t = !0) {
    if (t) {
      if (this.excludedPage)
        return;
      this.setAttribute("data-visible", "true");
    } else
      this.removeAttribute("data-visible");
  }
  handleFauxClick() {
    d(
      () => {
        this.initLiveChat(!0);
      },
      null,
      ["marketing", "analytics"],
      !0,
      !0
    );
  }
  handleExternalClicks(t) {
    (t.target.hasAttribute("data-open-chat") || t.target.getAttribute("href") === "#chat") && (t.preventDefault(), this.hasAttribute("data-visible") ? this.button.click() : this.initLiveChat(!0));
  }
  get excludedPage() {
    return !1;
  }
}
window.customElements.define("live-chat", v);
class m extends HTMLElement {
  constructor() {
    super();
    l(this, "consentDebug", !1);
    this.CHAT_READY_MESSAGE = '<p>Chat is also available. <a href="#chat">Click here to start chatting with us.</a></p>', this.CHAT_AVAILABLE_MESSAGE = '<p>Chat is also available, but it requires your consent to certain cookies. Please <button class="underline" onclick="window.consentBanner.showConsentPreferences()">adjust your cookie consent here</button> to allow marketing and analytics cookies.</p>';
  }
  static get observedAttributes() {
    return ["data-cookie-consent"];
  }
  connectedCallback() {
    this.style.display = "contents", d(
      () => {
        this.setAttribute("data-cookie-consent", "true");
      },
      () => {
        this.setAttribute("data-cookie-consent", "false");
      },
      ["marketing", "analytics"],
      !1,
      this.consentDebug
    ), f(
      () => {
        this.setAttribute("data-cookie-consent", "true");
      },
      () => {
        this.setAttribute("data-cookie-consent", "false");
      },
      ["marketing", "analytics"],
      this.consentDebug
    );
  }
  attributeChangedCallback(t, s, n) {
    t === "data-cookie-consent" && (n === "true" && s != "true" ? this.render(!0) : this.render(!1));
  }
  render(t = !1) {
    this.innerHTML = t ? this.CHAT_READY_MESSAGE : this.CHAT_AVAILABLE_MESSAGE;
  }
}
window.customElements.define("chat-notice", m);
export {
  m as ChatNotice,
  v as LiveChat
};
